import React, { useState, useEffect } from "react";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { CreateCompetencyCategoryData } from "../../services/CompetencyCategoryService";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import api from "../../api";
import { decryptDataFromArray } from "helpers/EncDec";
import { MultiSelect } from "react-multi-select-component";
import { Trans, useTranslation } from "react-i18next";

const CountdownTimer = ({ initialSeconds }) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer); // Cleanup the timeout on unmount
    }
  }, [seconds]);

  return (
    <div className="second-row">
      <h5>{seconds} seconds</h5>
    </div>
  );
};

function CreateCompetencyCategory() {
  const { t } = useTranslation();
  const history = useHistory();
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: t(`mcq_manager.Active`), value: "1", id: "1" },
    { label: t(`mcq_manager.Inactive`), value: "0", id: "0" },
  ]);
  const [vacancyType, setVacancyType] = useState([]);
  const [Job, setJob] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [statePayload, setStatePayload] = useState({});
  const [testdata, setTestdata] = useState([]);
    const [selectedHour, setSelectedHour] = useState(null);
  const [selectedMinSec, setSelectedMinSec] = useState(null);
  const fetchAllTestRounds = async allJobValues => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/screening/fetch-alltestrounds`,
        { jobTitleIds: allJobValues },
      );

      const testdata = response.data.titlelist;
      console.log(testdata,"Test data");
      let data = testdata?.map(item => ({
        id: item?.id,
        label: item?.name,
        value: item?.id,
      }));
      
      setTestdata(data);
    } catch (err) {
      console.log("Error:::", err);
    }
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  const handleSelectAll = () => {
    setSelectedOptions(Job || []);
    const allJobValues = (Job || [])?.map(Job => Job.id);
    setStatePayload(prevState => ({
      ...prevState,
      Job_id: allJobValues, // Update Job_id in statePayload with all Job values
    }));
  };
  const handleDeselectAll = () => {
    setSelectedOptions([]);
  };
  const handleChanges = selectedOptions => {
    setSelectedOptions(selectedOptions);
    const allJobValues = selectedOptions?.map(Job => Job.id);
    console.log("allJobValues", allJobValues);
    fetchAllTestRounds(allJobValues);
    setFormDataValues(prevState => ({
      ...prevState,
      Job_id: allJobValues, // Update Job_id in statePayload with all Job values
    }));
  };
  const extendedOptions = [
    // {
    //   value: "buttons",
    //   label: (
    //     <div className="d-flex gap-2">
    //       <button className="selectall-btn" onClick={handleSelectAll}>
    //         Select All
    //       </button>
    //       <button className="selectall-btn" onClick={handleDeselectAll}>
    //         Deselect All
    //       </button>
    //     </div>
    //   ),
    //   isDisabled: true,
    // },
    ...Job,
  ];

  useEffect(() => {
    const lang_id =
      localStorage.getItem("lang_id") !== "1"
        ? localStorage.getItem("lang_id")
        : "1";
    GetVacancyTypeList(lang_id)
      .then(res => {
        let responseData = decryptDataFromArray(res?.data);
        if (responseData?.status) {
          let vacrr = responseData?.data?.map(item => ({
            label: item?.title,
            value: item?.id,
            id: item?.id,
          }));
          setVacancyType(vacrr);
        } else {
          toast.error(t(`mcq_manager.NoDataAvailable`));
        }
      })
      .catch(err => {
        toast.error(t(`mcq_manager.NoDataAvailable`));
      });
  }, []);

  const handleChangeVacancyTypeValuePopulate = async e => {
    const lang_id =
      localStorage.getItem("lang_id") !== "1"
        ? localStorage.getItem("lang_id")
        : "1";
    let vacancy_type_id = e?.value;
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/job/fetch-jobbyvacancy/${vacancy_type_id}`
      )
      .then(response => {
        const alljobs = response.data.jobdata;
        let data = alljobs?.map(item => ({
          id: item?.id,
          label: item?.title,
          value: item?.id,
        }));
        setJob(data);
      })
      .catch(err => console.log("Error:::", err));
    setFormDataValues(prevState => ({
      ...prevState,
      vacancy_type_id: vacancy_type_id,
    }));
  };

  const handleChangeStatusValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formDataValues?.name) {
      newErrors.name = t(`mcq_manager.CompetencyCategoryRequired`);
      isValid = false;
    }

    if (!formDataValues?.vacancy_type_id) {
      newErrors.vacancy_type_id = t(`mcq_manager.VacancyTypeRequired`);
      isValid = false;
    }

    if (!formDataValues?.ques_count) {
      newErrors.ques_count = t(`mcq_manager.QuestionCountRequired`);
      isValid = false;
    }
    if (!formDataValues?.status) {
      newErrors.status = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }
    if (!formDataValues?.rounds) {
      newErrors.rounds = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }
    // if (!formDataValues?.duration) {
    //   newErrors.duration = t(`mcq_manager.DurationRequired`);
    //   isValid = false;
    // }
    if (selectedOptions?.length === 0) {
      newErrors.selectoption = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async e => {
    if (validateForm()) {
      let data = {
        vacancy_type_id: e?.vacancy_type_id,
        name: e?.name,
        ques_count: e?.ques_count,
        status: e?.status,
        Job_id: e?.Job_id,
        duration: e?.duration,
        rounds: e?.rounds,
      };

      CreateCompetencyCategoryData(data)
        .then(res => {
          if (res?.status === 200) {
            toast.success(res?.data?.message);
            history.push("/competency-category-list");
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          console.error("Error updating data:", err);
          setErrors("No data created.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  if (!checkPermissionStatus("competency-category-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }



  const generateOptions = count =>
    Array.from({ length: count }, (_, i) => ({
      value: i < 10 ? `0${i}` : `${i}`,
      label: i < 10 ? `0${i}` : `${i}`,
    }));

  const generateMinSecOptions = () => {
    let options = [];
    for (let i = 0; i < 60; i++) {
      for (let j = 0; j < 60; j++) {
        const min = i < 10 ? `0${i}` : `${i}`;
        const sec = j < 10 ? `0${j}` : `${j}`;
        options.push({
          value: `${min}:${sec}`,
          label: `${min}:${sec}`,
        });
      }
    }
    return options;
  };

  const hourOptions = generateOptions(24); // 00 to 23
  const minSecOptions = generateMinSecOptions(); // 00:00 to 59:59

  const handleHourChange = selectedOption => {
    setSelectedHour(selectedOption);
  };




  return (
    <>
      <div className="page-content">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/competency-category-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`mcq_manager.Configure Competency`)}
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link
                  to="/competency-category-list"
                  className="btn btn-primary"
                >
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy mt-3">
          <div className="form-details-section mt-3">
            <Container fluid>
              <AvForm
                className="outer-repeater"
                onValidSubmit={() => {
                  handleSubmit(formDataValues);
                }}
              >
                <div data-repeater-list="outer-group" className="outer">
                  <div data-repeater-item className="outer">
                    {successMessage && (
                      <div class="alert alert-success" role="alert">
                        {successMessage}
                      </div>
                    )}
                    {errorMessage && (
                      <div class="alert alert-danger" role="alert">
                        {errorMessage}
                      </div>
                    )}
                    <Row>
                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          <Label htmlFor="name" className="col-form-label">
                            {t(`mcq_manager.Competency`)}
                            <span className="text-danger">*</span>
                          </Label>
                          <AvField
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            placeholder={t(`mcq_manager.Competency Name`)}
                            title={t(`mcq_manager.Competency Name`)}
                            value={formDataValues?.name || ""}
                            onChange={handleChange}
                          />
                          {errors?.name && (
                            <div className="error">{errors?.name}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          {/* Associate label with the select element */}
                          <Label
                            htmlFor="vacancy_type_id"
                            className="col-form-label"
                          >
                            {t(`mcq_manager.Vacancy Type`)}
                            <span className="text-danger">*</span>
                          </Label>

                          <div
                            title={
                              formDataValues.vacancy_type_id
                                ? `${
                                    vacancyType?.find(
                                      elem =>
                                        elem.value ==
                                        formDataValues.vacancy_type_id
                                    )?.label
                                  }`
                                : `${t("mcq_manager.Vacancy Type")}`
                            }
                          >
                            <Select
                              className="mb-1"
                              placeholder={t(`mcq_manager.Select Type`)}
                              id="vacancy_type_id" // Matches the htmlFor attribute in the label
                              name="vacancy_type_id"
                              options={vacancyType}
                              onChange={handleChangeVacancyTypeValuePopulate}
                              aria-label={t(`mcq_manager.Vacancy Type`)} // Adds an ARIA label for screen readers
                              tabIndex="0" // Ensures it is focusable in the natural tab order
                            />
                          </div>

                          {/* Error message */}
                          {errors?.vacancy_type_id && (
                            <div className="error">
                              {errors?.vacancy_type_id}
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          <Label
                            htmlFor="vacancy_type_id"
                            className="col-form-label"
                          >
                            {t(`mcq_manager.Job Title`)}
                            <span className="text-danger">*</span>
                          </Label>
                          <div
                            className="selectoption"
                            title={
                              selectedOptions.length
                                ? `${selectedOptions
                                    .map(option => option.label || option.name)
                                    .join(", ")}`
                                : `${t("mcq_manager.Job Title")}`
                            }
                          >
                            <MultiSelect
                              // shouldToggleOnHover={true}
                              options={extendedOptions}
                              value={selectedOptions}
                              onChange={handleChanges}
                              overrideStrings={{
                                selectSomeItems: `Select Job Title`,
                              }}
                            />
                          </div>
                          {errors?.selectoption && (
                            <div className="error">{errors?.selectoption}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup className="mb-2">
                          <Label
                            htmlFor="vacancy_type_id"
                            className="col-form-label"
                          >
                            {t(`mcq_manager.Rounds`)}
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            id="rounds"
                            onChange={handleChange}
                            name="rounds"
                            className="form-control"
                            data-width="100%"
                            onMouseEnter={e => {
                              e.target.setAttribute(
                                "title",
                                e.target.options[e.target.selectedIndex].text
                              );
                            }}
                          >
                            <option selected disabled>
                              {t(`mcq_manager.Select Rounds`)}
                            </option>
                            {testdata?.map(el => {
                              return (
                                <option value={el?.value}>{el?.label}</option>
                              );
                            })}
                          </select>
                          {errors?.rounds && (
                            <div className="error">{errors?.rounds}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          {/* Ensure only one label is associated */}
                          <Label
                            htmlFor="ques_count"
                            className="col-form-label"
                          >
                            {t(`mcq_manager.Question Count`)}
                            <span className="text-danger">*</span>
                          </Label>

                          <div title={t("mcq_manager.Question Count")}>
                            <AvField
                              type="number"
                              className="form-control"
                              id="ques_count"
                              name="ques_count"
                              placeholder={t(`mcq_manager.Question Count`)}
                              value={formDataValues?.ques_count || ""}
                              onChange={handleChange}
                            />
                          </div>
                          {errors?.ques_count && (
                            <div className="error">{errors?.ques_count}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          {/* Label associated with input */}
                          <Label htmlFor="duration" className="col-form-label">
                            {t(`mcq_manager.Duration(in minutes)`)}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          {/* Input field with matching ID */}
                          <div title={t(`mcq_manager.Duration(in minutes)`)}>
                            <AvField
                              type="number"
                              className="form-control"
                              id="duration" // Matches the htmlFor attribute in the Label
                              name="duration"
                              placeholder={t(`mcq_manager.Duration`)}
                              value={formDataValues?.duration || ""}
                              onChange={handleChange}
                            />
                          </div>
                          {/* Error message */}
                          {errors?.duration && (
                            <div className="error">{errors?.duration}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          {/* Label associated with the select */}
                          <Label className="col-form-label" htmlFor="status_id">
                            {t(`mcq_manager.Status`)}
                            <span className="text-danger">*</span>
                          </Label>
                          {/* Select component with ARIA attributes */}

                          <div
                            title={
                              formDataValues.status
                                ? `${
                                    status.find(
                                      elem =>
                                        elem.value == formDataValues.status
                                    )?.label
                                  }`
                                : `${t("mcq_manager.Select Status")}`
                            }
                          >
                            <Select
                              className="mb-3"
                              placeholder={t(`mcq_manager.Select Status`)}
                              id="status_id" // Matches the htmlFor attribute in the label
                              name="status"
                              options={status}
                              onChange={handleChangeStatusValuePopulate}
                              aria-label={t(`mcq_manager.Select Status`)} // Adds an ARIA label
                              tabIndex="0" // Explicitly specifies focusable tabindex
                            />
                          </div>
                          {/* Error message */}
                          {errors?.status && (
                            <div className="error">{errors.status}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <div className="cta gap-3 text-center d-flex justify-content-left mt-4 mb-4">
                        <Button
                          type="button"
                          className="btn btn-secondary"
                          onClick={e => {
                            e.preventDefault();
                            history.push("/competency-category-list");
                          }}
                        >
                          {t(`mcq_manager.Cancel`)}
                        </Button>
                        <Button
                          type="submit"
                          color="success"
                          className="btn btn-primary"
                        >
                          {t(`mcq_manager.Submit`)}
                        </Button>
                      </div>
                    </Row>
                  </div>
                </div>
              </AvForm>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateCompetencyCategory;
